const EN_LOCALE_ONLY = process.env.EN_LOCALE_ONLY === 'true'
const IN_BROWSER = typeof window !== 'undefined'
const IS_DEBUG = process.env.DEBUG === 'true'
const IS_PROD = process.env.NODE_ENV === 'production'
const VUE_ENV = process.env.VUE_APP_ENV;
const VUE_APP_APIPATH = VUE_ENV === 'local' ? process.env.VUE_APP_APIPATH : '/../api/'
const VUE_APP_HOST = VUE_ENV === 'local' ? process.env.VUE_APP_HOST : '/'

module.exports = {
  EN_LOCALE_ONLY,
  IN_BROWSER,
  IS_DEBUG,
  IS_PROD,
  VUE_APP_APIPATH,
  VUE_APP_HOST,
}
